export default {
  methods: {
    removeSpaces(str: string | null | undefined) {
      return String(str ?? '').replace(/\s+/g, '');
    },

    getStringLastPart(fieldName: string | null | undefined, delimiter: string) {
      const parts = String(fieldName ?? '').split(delimiter);
      return parts.length > 1 ? +parts[1] : 0;
    },

    formatText(input: string | null | undefined, split = '_') {
      return String(input ?? '')
        .split(split)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(' ');
    },
    stringReplaceWithString(
      target: string,
      search: string,
      replacement: string,
    ): string {
      const finalString: string = target.split(search).join(replacement);
      return finalString;
    },
    normalizeString(value: string | null | undefined) {
      return String(value ?? '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    },
  },
};
